/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { TitleWrap, TotalTabWrap } from '@styles/base.style'
import { Tabs } from 'antd-mobile'
import { Models } from 'rmc-tabs'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { isMobile } from 'react-device-detect'
import { BackBtn } from '@styles/button.style'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import { SearchWrap } from '@views/BettorFind/index.style'
import { Input } from 'antd'
import { showToast, TOAST_TYPE } from '@utils/utils'
import _ from 'lodash'
import { BETTOR_FIND_TYPE, NICKNAME_LENGTH } from '@v2/constants/common'
import MessageArrivalButton from '@components/Button/MessageArrivalButton'
import Chat from '@views/Popup/Chat'
import NavBar from '@views/Navbar'
import classNames from 'classnames'
import { BettorFindList } from './BettorFindList'

const { Search } = Input
let fetchBettorListTimer = null

const BettorFind: React.FC = observer(() => {
  const { bettorStore, authStore, routerStore, chattingStore, userPickStore, logStore } = useRootStore()
  const { isChatEnabled } = chattingStore

  const [currentTabKey, setCurrentTabKey] = useState<BETTOR_FIND_TYPE>(BETTOR_FIND_TYPE.NEW_MEMBER)
  const [searchNick, setSearchNick] = useState('')

  useOnMount(() => {
    if (!authStore.isSignedIn) {
      routerStore.push('/')
    }

    fetchBettorList(true)
  })

  useEffect(() => {
    if (currentTabKey !== BETTOR_FIND_TYPE.ALL_BETTOR) {
      setSearchNick('')
    }
    fetchBettorList(true)

    setTimeout(() => {
      const element = document.querySelector(`#bettorListWrap`).children[0]
      if (element) element.scrollTop = 0
    }, 400)
  }, [currentTabKey])

  useOnUnmount(() => {
    userPickStore.resetUserPickMine()
    bettorStore.resetBettorFindState()
  })

  const isClearButtonEvent = (value: string) => {
    return _.isEmpty(_.trim(value))
  }

  const fetchBettorList = (reset = false) => {
    clearTimeout(fetchBettorListTimer)
    fetchBettorListTimer = setTimeout(() => {
      bettorStore.fetchBettors(currentTabKey, searchNick, reset).catch(console.error)
    }, 200)
  }

  const validateSearchNickName = (nickName: string): boolean => {
    return !(_.isEmpty(_.trim(nickName)) || _.size(nickName) < NICKNAME_LENGTH.MIN)
  }

  const doClickSearchBtn = (
    value: string,
    event?: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLInputElement>
  ): void => {
    // 클리어 버튼을 이용한 경우는 토스트 메시지를 표시하지 않는다.
    if (_.isNil(event['key']) && event?.target['id'] === 'better_nick_search_input' && isClearButtonEvent(value)) {
      setSearchNick('')
      if (currentTabKey !== BETTOR_FIND_TYPE.NEW_MEMBER) {
        setCurrentTabKey(BETTOR_FIND_TYPE.NEW_MEMBER)
      } else {
        fetchBettorList(true)
      }
      return
    }

    if (validateSearchNickName(value)) {
      if (currentTabKey !== BETTOR_FIND_TYPE.ALL_BETTOR) {
        setCurrentTabKey(BETTOR_FIND_TYPE.ALL_BETTOR)
      } else {
        fetchBettorList(true)
      }
      return
    }

    showToast(TOAST_TYPE.WARN, '2글자 이상 입력해야 합니다.')
  }

  const bettorTabList = useMemo<Models.TabData[]>((): Models.TabData[] => {
    return [
      {
        title: (
          <span className="tab-item large-txt">
            <span className="txt">신규가입</span>
          </span>
        ),
        name: '신규가입',
        key: BETTOR_FIND_TYPE.NEW_MEMBER.toString(),
      },
      // {
      //   title: (
      //     <span className="tab-item large-txt">
      //       <span className="txt">첫 베팅</span>
      //     </span>
      //   ),
      //   name: '첫 베팅',
      //   key: BETTOR_FIND_TYPE.FIRST_BET.toString(),
      // },
      {
        title: (
          <span className="tab-item large-txt">
            <span className="txt">오늘의 베터</span>
          </span>
        ),
        name: '오늘의 베터',
        key: BETTOR_FIND_TYPE.TODAY_BETTOR.toString(),
      },
      {
        title: (
          <span className="tab-item large-txt">
            <span className="txt">적중</span>
          </span>
        ),
        name: '적중',
        key: BETTOR_FIND_TYPE.BET_HIT_SUCCESS.toString(),
      },
      {
        title: (
          <span className="tab-item large-txt">
            <span className="txt">전체</span>
          </span>
        ),
        name: '전체',
        key: BETTOR_FIND_TYPE.ALL_BETTOR.toString(),
        className: 'bettor-find-all',
      },
    ]
  }, [])

  const onChange = (tab: Models.TabData) => {
    setCurrentTabKey(Number(tab.key) as BETTOR_FIND_TYPE)
  }

  const onChangeNickSearchField = event => {
    setSearchNick(event.target.value)
  }

  const searchClass = classNames('white-search', {
    'white-search pc-search-wrap': !isMobile,
  })

  return (
    <Fragment>
      {isMobile && (
        <TitleWrap className="title-wrap white">
          <BackBtn onClick={() => {
            logStore.writeButtonLog({ pageId: 'd050', buttonId: '001' }).catch(console.error)
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>
      )}

      <SearchWrap className={searchClass}>
        <Search
          id="better_nick_search_input"
          value={searchNick}
          className="nick"
          placeholder="베터 닉네임을 검색하세요"
          enterButton="검색"
          onSearch={doClickSearchBtn}
          onChange={onChangeNickSearchField}
          allowClear
        />
      </SearchWrap>
      <TotalTabWrap whiteUnderline className="left-align bettor-find-tabs">
        <Tabs
          tabs={bettorTabList}
          page={currentTabKey.toString()}
          onChange={onChange}
        />
      </TotalTabWrap>
      <BettorFindList bettorFindType={currentTabKey} searchNick={searchNick}/>

      <MessageArrivalButton key="Bettor:MessageArrivalButton"/>
      {isChatEnabled && !authStore.isSpecificClubMember && isMobile && <Chat key="BettorFind:Chat"/>}
      {isMobile && <NavBar key="Bettor:NavBar"/>}
    </Fragment>
  )
})

export default BettorFind
